import type { InjectionKey, Ref } from 'vue';

declare global {
	interface Window {
		adngin: {
			queue: (() => void)[];
			cmd: {
				startAuction: () => void;
			};
		};
	}
}

export const loadAdSnigel = async (resolve: () => void, reject: () => void) => {
	if (document.querySelector('script[src*="cdn.snigelweb.com"]')) {
		resolve();
		return;
	}

	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.async = true;
	script.setAttribute('data-cfasync', 'false');
	script.src = 'https://cdn.snigelweb.com/adengine/justwatch.com/loader.js';

	script.onload = () => resolve();
	script.onerror = () => {
		import('@/helpers/sentry-helper').then(({ captureMessageForSentry }) => {
			captureMessageForSentry(`[snigel-helper.ts]: Failed to load Snigel script`);
		});
		reject();
	};

	document.head.appendChild(script);
};

export function startSnigelAuction() {
	window.adngin = window.adngin || ({} as any);
	window.adngin.queue = window.adngin.queue || [];
	window.adngin.queue.push(() => window.adngin.cmd.startAuction());
}

// EXP_SNIGEL: the actual shared value (the titleId we last started an auction for) is provided once by
// TitleDetailV1.vue and injected here by every SnigelExpAdUnit instance, so startSnigelAuction() runs once
// per title - across all ad slots on the page - instead of once per ad unit. This is only the identifier
// for that provide/inject pair, not the state itself.
export const SNIGEL_AUCTION_TITLE_KEY: InjectionKey<Ref<string | null>> = Symbol('snigelAuctionTitleId');
